import type VueRouter from 'vue-router';
import clearPollGuard from './clearPoll';
import transferQueriesGuard from './transferQueries';
import referrerGuard from './referrer';
import bodyStyleGuard from './bodyStyle';
import titleGuard from './title';
import { setupRegisterPageGuard, trackPageViewGuard } from './tracker';
import type { Pinia } from 'pinia';
import saveUTMParamsGuard from './saveUTMParams';

export function installGuards(router: VueRouter, pinia: Pinia) {
  /**
   * 顺序有要求，请勿随意调整
   */
  [
    saveUTMParamsGuard, // beforeEach
    clearPollGuard, // beforeEach
    transferQueriesGuard, // beforeEach
    referrerGuard, // beforeEach
    setupRegisterPageGuard, // beforeEach
    bodyStyleGuard, // afterEach
    titleGuard, // afterEach
    trackPageViewGuard, // afterEach
  ].forEach((guard) => guard(router, pinia));
}
